import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useInsertData } from "../../hooks/useInsertData";
import { useGetData } from "../../hooks/useGetData";
import { useUpdateData } from "../../hooks/useUpdateDate";
import useDeleteData from "../../hooks/useDeleteData";

export const createStandardMaintenanceItem = createAsyncThunk("standardMaintenanceItem/createStandardMaintenanceItem", async (data, { rejectWithValue }) => {
  try {
    const res = await useInsertData("standardItems", data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});

export const getAllStandardMaintenanceItems = createAsyncThunk("standardMaintenanceItem/getAllStandardMaintenanceItems", async (_, { rejectWithValue }) => {
  try {
    const res = await useGetData("standardItems");
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getStandardMaintenanceItemsById = createAsyncThunk("standardMaintenanceItem/getStandardMaintenanceItemsById", async (id, { rejectWithValue }) => {
  try {
    const res = await useGetData(`standardItems/${id}`);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const updateStandardMaintenanceItem = createAsyncThunk("standardMaintenanceItem/updateStandardMaintenanceItem", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await useUpdateData(`standardItems/${id}`, data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const deleteStandardMaintenanceItem = createAsyncThunk("maintenanceItem/deleteStandardMaintenanceItem", async (id, { rejectWithValue }) => {
  try {
    const res = await useDeleteData(`standardItems/force/${id}`);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});

// export const getSpecificMaintenanceItem = createAsyncThunk("standardMaintenanceItem/getSpecificMaintenanceItem", async (id, { rejectWithValue }) => {
//   try {
//     const res = await useGetData(`maintenanceItems/${id}`);
//     return res.data;
//   } catch (err) {
//     if (err.response && err.response.data) {
//       return rejectWithValue(err.response.data);
//     }
//     return rejectWithValue(err.message);
//   }
// });

// export const getScheduleStateMaintenanceItem = createAsyncThunk("standardMaintenanceItem/getScheduleStateMaintenanceItem", async (id, { rejectWithValue }) => {
//   try {
//     const res = await useGetData(`maintenanceItems/schedule/stats/${id}`);
//     return res.data;
//   } catch (err) {
//     if (err.response && err.response.data) {
//       return rejectWithValue(err.response.data);
//     }
//     return rejectWithValue(err.message);
//   }
// });

// export const getDeletedMaintenanceItem = createAsyncThunk("standardMaintenanceItem/getDeletedMaintenanceItem", async (_, { rejectWithValue }) => {
//   try {
//     const res = await useGetData(`maintenanceItems/deleted`);
//     return res.data;
//   } catch (err) {
//     if (err.response && err.response.data) {
//       return rejectWithValue(err.response.data);
//     }
//     return rejectWithValue(err.message);
//   }
// });

const initialState = {
  standardMaintenanceItem: null,
  allStandardMaintenanceItems: null,
  detailsStandardMaintenanceItemsById: null,
  status: "idle",
  error: null,
  token: null,
};
export const standardMaintenanceItemSlice = createSlice({
  name: "StandardMaintenanceItemSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createStandardMaintenanceItem.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createStandardMaintenanceItem.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.standardMaintenanceItem = action.payload;
      })
      .addCase(createStandardMaintenanceItem.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getAllStandardMaintenanceItems.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllStandardMaintenanceItems.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allStandardMaintenanceItems = action.payload;
      })
      .addCase(getAllStandardMaintenanceItems.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getStandardMaintenanceItemsById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getStandardMaintenanceItemsById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.detailsStandardMaintenanceItemsById = action.payload;
      })
      .addCase(getStandardMaintenanceItemsById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(deleteStandardMaintenanceItem.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteStandardMaintenanceItem.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(deleteStandardMaintenanceItem.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
    // //---------------------------------------
    // .addCase(resendCode.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resendCode.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resendCodeResponse = action.payload;
    // })
    // .addCase(resendCode.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(loginUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(loginUser.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.currentUser = action.payload.data;
    //   state.token = action.payload.token;
    // })
    // .addCase(loginUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(getCurrentUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(getCurrentUser.fulfilled, (state, action) => {
    //   state.currentUser = action.payload.user;
    //   state.status = "succeeded";
    // })
    // .addCase(getCurrentUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(forgetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(forgetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.forgetPasswordResponse = action.payload;
    // })
    // .addCase(forgetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(resetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resetPasswordResponse = action.payload;
    // })
    // .addCase(resetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(updateUserData.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(updateUserData.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.user = action.payload;
    // })
    // .addCase(updateUserData.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // });
  },
});
export default standardMaintenanceItemSlice.reducer;
